import { Divider, List, ListItem, Grid } from '@material-ui/core'
import React from 'react'

import { useLiterals } from '~/components/Literals'
import ProductCard from './ProductCard'

export default function ProductsList({ products, handleProductClick }) {
  const { getLiteral } = useLiterals()

  return (
    <List>
      {products.map((product, index) => (
        <Grid key={index}>
          <Divider />
          <ListItem key={product.gtin}>
            <ProductCard product={product} getLiteral={getLiteral} productClick={() => handleProductClick(product)} />
          </ListItem>
        </Grid>
      ))}
    </List>
  )
}
